// flow weak

import React, {
    Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  import {Link} from 'react-router-dom';
  
  class EditVenue extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        venue_id: props.match.params.id,
        venue_details: {
            venue_name:'',
            address:'',
            contact_number: '',
            landmark:'',
            city:'',
            location:'',
            start_time:'05:00',
            end_time:'23:00',
            is_active: false,
            is_thirty_min: false,
            is_court_booking: false,
            is_equipment_rental: false,
            // is_playo_enabled:false,
            is_test_venue: false,
            is_franchise: false,
            playo_api_token:'',
            playo_user_name:'',
            playo_user_password:'',
            non_operational_start_time:'00:00',
            non_operational_end_time:'05:00',
            image1: '',
            image2:'',
            image3:'',
            image4:'',
            latitude:'',
            longitude:'',
            direction:'',
            description:''
        }, 
        revenue_share: [],
        amenities: [],
        utilities: [],
        city_arr: [],
        location_arr: [],
        buddies_arr: [],
        game_types: [],
        selected_games: [],
        selected_amenities: [],
        selected_utilities: [],
        selected_buddies: [],
        available_games: [],
        available_amenities: [],
        available_utilities: [],
        available_buddies: [],
        selected_city:'',
        selected_location:'',
        temp_list_game: [],
        temp_list_amenity: [],
        temp_list_utility: [],
        temp_available_games: [],
        temp_available_utilities:[],
        temp_available_amenities:[],
        temp_available_buddies:[],
        temp_list_buddies:[],
        temp_revenue_list:[],
        search:false,
        customer_search_list: [],
        dialog_open_cust:true,
        amount:0,
        dialog:false,
        temp_images:{
          image1:'',
          image2:'',
          image3:'',
          image4:''
        },
        success:false,
        message:''
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onStartTimeChange = this.onStartTimeChange.bind(this)
      this.onEndTimeChange = this.onEndTimeChange.bind(this)
      this.onNonOperationalStartTimeChange = this.onNonOperationalStartTimeChange.bind(this)
      this.onNonOperationalEndTimeChange = this.onNonOperationalEndTimeChange.bind(this)
      this.handleImages = this.handleImages.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      this.handleCityChange = this.handleCityChange.bind(this);
      this.handleLocationChange = this.handleLocationChange.bind(this);
      this.postImageUpload = this.postImageUpload.bind(this);
      this.handleRevenueShare = this.handleRevenueShare.bind(this);
      this.getRevnueShare = this.getRevnueShare.bind(this);
    }
  
    componentDidMount() {
        this.getDetails();
        // this.getVenueDetails();
    }

    handlecustClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }    

    getDetails(){
      const url = `${getLocationOrigin()}/get_venue_list/get_details_for_venue_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({city_arr:data.result.location,
            amenities:data.result.amenities,utilities:data.result.utilities,game_types:data.result.game_types,
            location_arr:data.result.location[0].locations, buddies_arr: data.result.buddies},()=>{this.getVenueDetails();});
           // alert("fix");
       }).catch(error => error);
    }

    getVenueDetails(){
      console.log('getVenueDetails')
      console.log('venue_id',this.state.venue_id)
     const url = `${getLocationOrigin()}/get_venue_list/get_venue_details/?venue_id=${this.state.venue_id}`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         if(data.success){
           this.setState({success:data.success,message:data.message},()=>{this.setData(data.result)});
         }
         else{
          this.setState({success:data.success,message:data.message})
           // alert("fix");
         }
       }).catch(error => error);
    }

    setData(result) {
      console.log('setData',this.state.game_types)
      console.log('result',result);
      var city = this.state.city_arr
      var loc = city.find(temp=> temp.city_id == result.location.city)
      console.log('location',loc.locations);
      const all_games = this.state.game_types
      const game_list = result.available_games
      var available_games = all_games.filter(game => game_list.includes(game.pk))
      var available_utilities = this.state.utilities.filter(utility => result.utilities.includes(utility.id))
      var available_amenities = this.state.amenities.filter(amenity => result.amenities.includes(amenity.id))
      var available_buddies = this.state.buddies_arr.filter(buddy => result.buddies.includes(buddy.id))

      var new_value =  Object.assign({}, this.state.venue_details);
      var images = Object.assign({}, this.state.temp_images);
      new_value['venue_name'] = result.name
      new_value['address'] = result.full_address
      new_value['contact_number'] = result.contact_no
      new_value['landmark'] = result.landmark
      new_value['city'] = result.location.city
      new_value['location'] = result.location.hood
      new_value['latitude'] = result.location.latitude
      new_value['longitude'] = result.location.longitude
      new_value['direction'] = result.location.map
      new_value['description'] = result.description
      new_value['is_active'] = result.is_active
      new_value['is_court_booking'] = result.is_court_booking_allowed
      new_value['is_equipment_rental'] = result.is_equipment_rental_available
      new_value['is_playo_enabled'] = result.is_playo_enabled
      new_value['is_test_venue'] = result.is_test_venue
      new_value['is_thirty_min'] = result.is_thirty_min_slot_allowed
      new_value['is_franchise'] = result.is_franchise

      if(result.start_time && result.end_time){
        new_value['start_time'] = result.start_time.substring(0,5)
        new_value['end_time'] = result.end_time.substring(0,5)
      }
      new_value['playo_api_token'] = result.playo_api_token
      new_value['playo_user_name'] = result.playo_user_name
      new_value['playo_user_password'] = result.playo_user_password
      if(result.non_operational_start_time && result.non_operational_end_time){
        new_value['non_operational_start_time'] = result.non_operational_start_time.substring(0,5)
        new_value['non_operational_end_time'] = result.non_operational_end_time.substring(0,5)
      }
      new_value['image1'] = result.picture
      new_value['image2'] = result.picture_extra_1
      new_value['image3'] = result.picture_extra_2
      new_value['image4'] = result.picture_extra_3
      
      images['image1'] = result.picture
      images['image2'] = result.picture_extra_1
      images['image3'] = result.picture_extra_2
      images['image4'] = result.picture_extra_3

      console.log('images',images)

      this.setState({venue_details:new_value, temp_images:images, location_arr:loc.locations,available_games:available_games,selected_games:result.available_games,
        temp_available_games:available_games,temp_available_amenities:available_amenities, selected_amenities:result.amenities, selected_utilities:result.utilities,
        temp_available_utilities:available_utilities, available_utilities:available_utilities, available_amenities:available_amenities,
        selected_buddies:result.buddies, available_buddies:available_buddies,temp_available_buddies:available_buddies, revenue_share:result.revenue_share})
    }



    postImageUpload(props) {
        console.log('inside postImageUpload')
        const url = `${getLocationOrigin()}/get_venue_list/upload_venue_images/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        var formData = new FormData();
        formData.append('venue_id',this.state.venue_id);
        formData.append('image1',this.state.venue_details.image1);
        formData.append('image2',this.state.venue_details.image2);
        formData.append('image3',this.state.venue_details.image3);
        formData.append('image4',this.state.venue_details.image4);
        options['body'] = formData
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                      // first then()
              if(response.success){
                alert(response.message);
                props.history.goBack();
                // window.location.reload()
              }
              else{
                alert(response.message);
              }
              
            })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });

    }


    postUpdateBooking(details,revenue_share,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/get_venue_list/update_venue/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'venue_id':this.state.venue_id,
                                          'venue_details': details,
                                          'game_types': this.state.selected_games,
                                          'amenities': this.state.selected_amenities,
                                          'utilities': this.state.selected_utilities,
                                          'buddies':this.state.selected_buddies,
                                          'revenue_share': revenue_share
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
              if(response.success){
                  this.setState(()=>{this.postImageUpload(props)})
              }
              else{
                alert(response.message)
              }
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    


    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        console.log(name,value)
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = target.type === 'checkbox' ? target.checked : target.value
        this.setState({venue_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        var rev_share = this.state.revenue_share.filter(share=> this.state.selected_games.includes(parseInt(share.game_id)))
        // console.log('rev_share',rev_share)
        // var sum = rev_share.reduce(function(total,each){
        //   return total + parseFloat(each.share)
        // },0)
        // var is_zero = rev_share.filter(each=>parseInt(each.share) == 0)
        // console.log('is_zero',is_zero)
        // if(this.state.venue_details.is_court_booking == false && sum != 100){
        //   alert('Total revenue share must be 100')
        // }
        // else if(this.state.venue_details.is_court_booking == false && is_zero.length > 0) {
        //   alert('Share must be greater than 0')
        // }
        // else{
          this.postUpdateBooking(this.state.venue_details,rev_share ,this.props)
        // }
      }

    onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['start_time'] = options
    this.setState({venue_details: new_value});
    }

    onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['end_time'] = options
    this.setState({venue_details: new_value});
    }

    onNonOperationalStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['non_operational_start_time'] = options
    this.setState({venue_details: new_value});
    }

    onNonOperationalEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value['non_operational_end_time'] = options
    this.setState({venue_details: new_value});
    }

    handleImages(event) {
    console.log('files',event.target.files)
    var image = event.target.files[0]
    var name = event.target.name
    console.log(name,image)
    var new_value =  Object.assign({}, this.state.venue_details);
    new_value[name] = image
    var images = Object.assign({}, this.state.temp_images);
    images[name] = window.URL.createObjectURL(image)
    this.setState({venue_details:new_value, temp_images:images})
    // document.getElementById(name).src = window.URL.createObjectURL(image)
    }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        if(name=== 'game'){
            this.state.temp_list_game.push(optionsList.pk)
            this.state.temp_available_games.push(optionsList)
            this.setState({ selected_games: this.state.temp_list_game,selected_name: name,available_games:this.state.temp_available_games});
        }
        else if(name === 'amenity'){
            this.state.temp_list_amenity.push(optionsList.id)
            this.state.temp_available_amenities.push(optionsList)
            this.setState({ selected_amenities:this.state.temp_list_amenity , selected_name: name});
        }
        else if(name === 'utility'){
            this.state.temp_list_utility.push(optionsList.id)
            this.state.temp_available_utilities.push(optionsList)
            this.setState({selected_utilities: this.state.temp_list_utility, selected_name: name});
        }
        else if(name === 'buddy'){
            this.state.temp_list_buddies.push(optionsList.id)
            this.state.temp_available_buddies.push(optionsList)
            this.setState({selected_buddies: this.state.temp_list_buddies, selected_name: name});
        }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'game'){
        this.setState({selected_games:dataItem.map(x => x.pk),selected_name: name ,available_games:dataItem.map(x =>x)});
      }
      else if(name === 'amenity'){
        this.setState({selected_amenities:dataItem.map(x => x.id), selected_name: name, available_amenities:dataItem.map(x =>x)});
      }
      else if(name === 'utility' ){
        this.setState({selected_utilities: dataItem.map(x => x.id), selected_name: name, available_utilities:dataItem.map(x =>x)});
      }
      else if(name === 'buddy' ){
        this.setState({selected_buddies: dataItem.map(x => x.id), selected_name: name, available_buddies:dataItem.map(x =>x)});
      }
    }

    setLocation(){
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value['city'] = this.state.selected_city
        new_value['location'] = this.state.selected_location
        this.setState({venue_details: new_value});
    }

    handleCityChange(event){
        console.log('city',event.target.value)
        const city = this.state.city_arr
        const value = event.target.value
        const name = event.target.name
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = value
        const loc = city.find(temp=> temp.city_id == value)
        new_value['location'] = loc.locations[0].location_id
        this.setState({venue_details: new_value,location_arr:loc.locations}); 
    }

    handleLocationChange(event) {
        const value = event.target.value
        const name = event.target.name
        var new_value =  Object.assign({}, this.state.venue_details);
        new_value[name] = value;
        this.setState({venue_details: new_value});
    }

    handleRevenueShare(event) {
      const value = event.target.value
      const name = event.target.name
      var new_value =  {}
      new_value['game_id'] = name
      new_value['share'] = value
      var temp_data = this.state.revenue_share
      var check = true
      for (var i = temp_data.length - 1; i >= 0; i--) {
        if(temp_data[i].game_id == name){
          temp_data[i].share = value
          check = false
        }
      }

      if(check){
        temp_data.push(new_value)
      }
      this.setState({revenue_share:temp_data,temp_revenue_list:temp_data})
    }

    getRevnueShare(id){
      var sel_revenue = this.state.revenue_share.find(share=>share.game_id == id)
      if(sel_revenue){
        return sel_revenue.share
      }
      return 0
    }


  
    render() {
      console.log('amount')
      console.log(this.state.venue_details);
      console.log(this.state.selected_buddies)

      var available_game_types = []
        if(this.state.selected_games.length > 0){
        available_game_types = this.state.game_types.filter(game_type=> this.state.selected_games.includes(game_type.pk))
        console.log('available_game_types',available_game_types)
     }

      const actionscust = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handlecustClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];  
      return(
        <div className='row' style={{display:'flex',flexDirection:'column'}}>
          <div className='col-md-12'>
            <Link to={`../addCourt/${this.state.venue_id}`}>
              <button className='button1' style={{float:'right'}}> Add Court </button>
            </Link>
            { this.state.venue_details.is_active && this.state.venue_details.is_court_booking &&
              <Link to={`../editCourtPricing/${this.state.venue_id}`}>
                <button className='button1' style={{float:'right',marginRight:'1%'}}> Edit Pricing </button>
              </Link>
            }
          </div>
          

          <div style={styles.container}> 

            <div className="row col-md-9 table-bordered" style={styles.table}>
              <div style={styles.main_header} className="col-md-12 label_blue_1">
                <h3 style={{textAlign:'center'}}> Edit Venue</h3>
              </div>
              { this.state.success ?
                <form  className="validated-form form-horizontal">

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Venue Name
                    </div>
                    <input style={styles.input} name="venue_name" value={this.state.venue_details.venue_name}
                    onChange={this.handleChange} />
                  </div>

                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Address
                    </div>
                    <textarea style={styles.textbox} name="address" value={this.state.venue_details.address}
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Landmark
                    </div>
                    <textarea style={styles.textbox} name="landmark" value={this.state.venue_details.landmark}
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    City
                  </div>
                 <select name="city" className="col-md-6" style={styles.item_body} value={this.state.venue_details.city}
                   onChange={this.handleCityChange}>
                    {
                       this.state.city_arr.map((location,index)=>(
                         <option key={location.city_id} value={location.city_id}>{location.city}</option>
                        ))
                     }
                 </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Location
                  </div>
                 <select name="location" className="col-md-6" style={styles.item_body} value={this.state.venue_details.location}
                   onChange={this.handleLocationChange}>
                    {
                       this.state.location_arr.map((location,index)=>(
                         <option key={location.location_id} value={location.location_id}>{location.name}</option>
                        ))
                     }
                 </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Latitude
                    </div>
                    <input style={styles.input}  name="latitude" value={this.state.venue_details.latitude}
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Longitude
                    </div>
                    <input style={styles.input}  name="longitude" value={this.state.venue_details.longitude}
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Direction Link
                    </div>
                    <input style={styles.input}  name="direction" value={this.state.venue_details.direction}
                    onChange={this.handleChange} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Contact Number
                  </div>
                  <input type="number" style={styles.input} name="contact_number" maxLength={10} value={this.state.venue_details.contact_number}
                  onChange={this.handleChange}/>
                </div>


                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Description
                  </div>
                  <textarea style={styles.textbox} name="description" rows="5" value={this.state.venue_details.description}
                  onChange={this.handleChange}/>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                        <div style={{width:'70%'}}>
                            <TimePicker className="col-md-3" theme="classic" time={this.state.venue_details.start_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                        </div>
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                        <div style={{width:'70%'}}>
                            <TimePicker className="col-md-3"  theme="classic" time={this.state.venue_details.end_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                        </div>
                    </div>
                </div>

                <div style={styles.items,{display:'flex',flexDirection:'column'}} className="col-md-12">
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is the venue active ? </div>
                        <div style={{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_active'
                        checked={this.state.venue_details.is_active} onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is thirty minutes allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_thirty_min' 
                        checked={this.state.venue_details.is_thirty_min} onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is equipment rental allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_equipment_rental' 
                        checked={this.state.venue_details.is_equipment_rental} onChange={this.handleChange}/></div>
                    </div>
                   
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is franchise venue ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_franchise' 
                        checked={this.state.venue_details.is_franchise} onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is test venue ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_test_venue' 
                        checked={this.state.venue_details.is_test_venue} onChange={this.handleChange}/></div>
                    </div>
                    <div style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">Is court booking allowed ? </div>
                        <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_court_booking' 
                        checked={this.state.venue_details.is_court_booking} onChange={this.handleChange}/></div>
                    </div>
                </div>

                { this.state.venue_details.is_court_booking ?
                    <div style={{marginTop:'1%'}}>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo Api Token
                            </div>
                            <input style={styles.input} name="playo_api_token" value={this.state.venue_details.playo_api_token}
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo User Name
                            </div>
                            <input style={styles.input} name="playo_user_name" value={this.state.venue_details.playo_user_name}
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Playo User Password
                            </div>
                            <input style={styles.input} name="playo_user_password" value={this.state.venue_details.playo_user_password}
                            onChange={this.handleChange} />
                        </div>
                        <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Non-operational Start Time </span>
                                <div style={{width:'70%'}}>
                                    <TimePicker className="col-md-3"  theme="classic" time={this.state.venue_details.non_operational_start_time} 
                                    name='non_operational_start_time' onTimeChange={this.onNonOperationalStartTimeChange} />
                                </div>
                            </div>
                            <div style={styles.item_header} className="col-md-6">
                                <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Non-operational End Time </span>
                                <div style={{width:'70%'}}>
                                    <TimePicker className="col-md-3" theme="classic" time={this.state.venue_details.non_operational_end_time} 
                                    name='non_operational_end_time' onTimeChange={this.onNonOperationalEndTimeChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    ''
                }


                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Venue Image
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image1" type='file' id='image' />
                        { this.state.venue_details.image1 ?
                        <img id="image1" src={this.state.temp_images.image1} alt="venue image" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 1
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image2" type='file' id='image' />
                        { this.state.venue_details.image2 ?
                        <img id="image2" src={this.state.temp_images.image2} alt="extra image 1" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 2
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image3" type='file' id='image' />
                        { this.state.venue_details.image3 ?
                        <img id="image3" src={this.state.temp_images.image3} alt="extra image 2" width="100" height="100" />
                        :
                        'No Image'
                        }
                    </div>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Extra Image 3
                    </div>
                    <div style={styles.item_header} className="col-md-6">
                        <input onChange={this.handleImages} accept='image/*' name="image4" type='file' id='image' />
                        { this.state.venue_details.image4 ?
                        <img id="image4" src={this.state.temp_images.image4} alt="extra image 3" width="100" height="100" />
                        :
                        'No Image '
                        }
                    </div>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Buddies
                    </div>
                    <div style={styles.item_body} className="col-md-6">
                        <Multiselect
                          id="3"  
                          placeholder="Click to select"
                          data={this.state.buddies_arr}
                          textField='buddy_name'
                          value = {this.state.available_buddies}
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                    </div>      

                </div>


                <div style={styles.items} className="col-md-12">
                    <div style={styles.items} className="col-md-4" style={{flexDirection:'column',marginTop: '8px'}}>
                        <Multiselect
                          id="3"  
                          placeholder="Available Games"
                          data={this.state.game_types}
                          textField='game'
                          value = {this.state.available_games}
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                    </div>      


                    <div style={styles.items} className="col-md-4" style={{flexDirection: 'column', marginTop: '8px'}}>
                        <Multiselect
                          id="1"
                          placeholder="Amenities"
                          data={this.state.amenities}
                          textField='value'
                          value = {this.state.available_amenities}
                          onSelect={this.onSelect} 
                          onChange={this.onChange} 
                          filter='contains'
                         />
                    </div>

                    <div style={styles.items} className="col-md-4" style={{flexDirection: 'column', marginTop: '8px'}}>
                        <Multiselect
                          placeholder="Utilities"
                          data={this.state.utilities}
                          textField='value'
                          value = {this.state.available_utilities}
                          onSelect={this.onSelect} 
                          onChange={this.onChange} 
                         /> 
                    </div>
                </div>

                { available_game_types.length > 0 ?
                  <div>
                    <div style={styles.items,{color:'red',fontSize:'1.5em',paddingLeft:'5%'}} className='col-md-12'>
                      Enter Revenue Share Percentage without % Symbol - i.e. 29.5
                    </div>
                    { available_game_types.map((game_type,index)=>
                    <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                            {game_type.game}
                        </div>
                        <input type='number' style={styles.input} name={game_type.pk} placeholder='Revenue Share i.e. 30.4 without %'
                        onChange={this.handleRevenueShare} value={this.getRevnueShare(game_type.pk)}/>
                    </div>
                    )
                    }
                  </div>
                  :
                  ''
                }

                <div style={styles.items,{color:'red',fontSize:'1em',paddingLeft:'5%'}} className='col-md-12'>
                    Please make sure all the provided details are correct
                </div>
               
                <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                  <div style={styles.button_submit} className="col-md-12">
                    <input className="button1" type="submit" value="Update Venue" onClick={this.handleSubmit}/>
                  </div>
                </div>
                  
              </form>
              :
              <div style={styles.message}>{this.state.message}</div>
            }
            </div>
          </div>
        </div>
      );
    }
  }
  
  export default EditVenue;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/editVenue/EditVenue.js